import { GLServiceBase, ServiceRoute } from "commonui";
import { ContentMediaDetail, IRevisionManagerService } from ".";
import { MediaNotesRequestModel, MediaPublishRequestModel } from "./model";

class RevisionMangerServiceClass extends GLServiceBase<any, any> implements IRevisionManagerService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/publishmedia" };

	getMedias(params: { gsVersion: string; lsVersion: string }): Promise<ContentMediaDetail[]> {
		return this.get("UnpublishedMedias", params);
	}

	saveMediasNote(model: MediaNotesRequestModel[]): Promise<boolean> {
		return this.update("SaveNotes", model, undefined);
	}

	publishMedias(model: MediaPublishRequestModel): Promise<boolean> {
		return this.create("ScheduleMediaPublish", model);
	}

	publishMediasImmediately(model: MediaPublishRequestModel): Promise<boolean> {
		return this.create("MediaPublish", model);
	}
}

export const RevisionManagerService = () => new RevisionMangerServiceClass();